<template>
  <div class="content">
    <div class="text">
      <p class="title" id="title">{{ title }}</p>
      <p
        class="desc"
        v-for="(item, index) in desc"
        :key="index"
      >
        {{ item.text }}
      </p>
      <div class="btn">
        <img src="@/assets/images/gp.png" class="btn" @click.stop="gpAction(false)"/>
        <!-- <img src="@/assets/images/ios.png" class="btn ios" @click.stop="gpAction(true)" alt=""> -->
      </div>
    </div>
    <img src="@/assets/images/screen.png" class="phone" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      desc: [],
      screen: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      console.log(config);
      // this.screen = `${config.baseUrl}images/screen.png?v=${new Date().getTime()}`;
      this.screen = `${config.screen}`;
      const { title, desc } = config.page[0];
      this.title = title;
      this.desc = desc;
    },
    gpAction(isIos = false){
      // window.gtagEvent('10001')
      // alert('Coming soon')
      // if (isIos) {
      //   window.open('https://apps.apple.com/us/app/id6503810311');
      // } else {
      //   window.open('https://play.google.com/store/apps/details?id=ai.character.talkie.waifu');
      // }
      window.open('https://play.google.com/store/apps/details?id=ai.spicy.character.spicychat.app');
    }
  },
};
</script>

<style lang="less">
.content {
  padding: 6px 0 28px;
  flex: 1;
  // background-image: url( "~@/assets/images/bg.png" );
  background-color: #2e2e2e;
  background-size: cover;
  width: 100%;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  .phone {
    width: 233px;
    border-radius: 3px;
  }
  .text {
    margin-right: 56px;
    max-width: 540px;
    //margin-top: 80px;
    img{
      width: 140px;
      margin-top: 12px;
    }
  }
  .title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    // line-height: 38px;
    margin-bottom: 20px;
  }
  .desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    margin-bottom: 18px;
  }
  .btn{
    cursor: pointer;
    &.ios{
      height: 36px;
      width: auto;
      margin-left: 30px;
    }
  }
}
</style>
